// extracted by mini-css-extract-plugin
export default {"peopleSearch":"PeopleSearch_peopleSearch__JrO+i","searchBox":"PeopleSearch_searchBox__yeB8s","content":"PeopleSearch_content__UDzbZ"};